import { AllowedValueTypeEnum, MaterialComponentUnit } from 'api';
import { type InferType, yup } from 'form';

export const MaterialComponentValueSchema = yup.object({
  allowed_value_type: yup.string().oneOf(Object.values(AllowedValueTypeEnum)).optional(),
  boolean_value: yup
    .boolean()
    .optional()
    .test('at-least-one-value', 'A value must be provided', function (value) {
      const { min_value, max_value } = this.parent;
      return value !== undefined || min_value !== undefined || max_value !== undefined || this.createError();
    }),
  max_value: yup
    .number()
    .optional()
    .min(0)
    .test('at-least-one-value', 'A value must be provided', function (value) {
      const { min_value, boolean_value } = this.parent;
      return value !== undefined || min_value !== undefined || boolean_value !== undefined || this.createError();
    }),
  min_value: yup
    .number()
    .optional()
    .min(0)
    .test('at-least-one-value', 'A value must be provided', function (value) {
      const { max_value, boolean_value } = this.parent;
      return value !== undefined || max_value !== undefined || boolean_value !== undefined || this.createError();
    }),
  supported_component_id: yup.number().required(),
  unit: yup.string().oneOf(Object.values(MaterialComponentUnit)).optional(),
});

export type MaterialComponentValueType = InferType<typeof MaterialComponentValueSchema>;
